import styled from 'styled-components'
import { PageMain } from 'styles/index'

export default styled(PageMain)`
  padding-top: 24px;
  ::-webkit-scrollbar {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track {
    background: #fbfbfb;
    border: 0;
  }
  ::-webkit-scrollbar-thumb {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
  .user-info {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 54px;
  }
  .small-title {
    font-size: 20px;
    font-weight: 500;
    text-align: left;
  }
  .section-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    flex-wrap: wrap;
  }
  .kanban-wrapper {
    gap: 24px;
  }
  .product-wrapper {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .card-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 16px;
    gap: 24px;
  }
  .card-wrapper:first-child {
    margin-top: 0;
  }
  .gray-line {
    height: 0;
    border: 0.25px solid #eeeeee;
    width: calc(100% - 24px); // 24px is the gap between the cards
  }
`
export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${window.innerHeight}px; /* Dynamic height */
  width: 100%;
`
